import type { ReactNode } from "react";
import { Zap } from "lucide-react";

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * Split-panel layout for authentication pages.
 * Left panel: brand visual (hidden on mobile). Right panel: form content.
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="auth-layout">
      <aside className="auth-layout__brand" aria-hidden="true">
        <div className="auth-layout__brand-content">
          <div style={{ marginBottom: "var(--z-space-8)" }}>
            <Zap size={48} strokeWidth={2.5} />
          </div>
          <h2>Build your website without code</h2>
          <p>
            Choose a profession, pick a template, customize everything, and
            publish — all in minutes.
          </p>
        </div>
      </aside>

      <main className="auth-layout__main">
        <div className="auth-card">
          <div className="auth-card__logo">
            <span className="auth-card__logo-icon">
              <Zap size={22} />
            </span>
            <span className="auth-card__logo-text">Zirro</span>
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
